import React from "react";
//#region types
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { SalaryFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { AuthEnums } from "models/enums";
//#endregion
//#region components
import {
  DashboardButtonGroup,
  FilterButton,
  PageLayouts,
  ReportSearchInput,
  SearchContextProvider,
} from "components/common";
import useSalarySpecificationActions from "components/salary/actions/useMoreActions";
import useSalarySpecificationReportFilterDefinition from "./useSalarySpecificationReportFilterDefinition";
import SalarySpecificationListView from "./listView";
import { Grid } from "@mui/material";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import { CompanyService } from "services";

const SalarySpecificationReport: React.FC = () => {
  const { filterFormFields, filterQueryStateHandler } = useSalarySpecificationReportFilterDefinition();
  const hasPermissions = CompanyService.hasRelations([AuthEnums.PersonCompanyRelationType.SalaryAdmin], false);
  const { generateSalarySpecMoreAction } = useSalarySpecificationActions();

  const topRightButtons = (
    <DashboardButtonGroup
      buttons={[
        <ReportSearchInput
          placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.SearchEmployee)}
        />,
        ACTION_SEPARATOR,
        <FilterButton />,
      ]}
      moreActions={[generateSalarySpecMoreAction]}
    />
  );

  return (
    <SearchContextProvider>
      <PageLayouts.DashboardLayout<SalaryFormTypes.SalarySpecificationFilter>
        entityKey={0}
        hasPermissions={hasPermissions}
        title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.SalarySpecifications)}
        topRightButtons={topRightButtons}
        filterFields={filterFormFields}
        filterQueryStateHandler={filterQueryStateHandler}
        initialFilter={{ year: DateHelper.getYear(DateHelper.today()) }}
      >
        <Grid container item>
          <SalarySpecificationListView />
        </Grid>
      </PageLayouts.DashboardLayout>
    </SearchContextProvider>
  );
};

export default SalarySpecificationReport;
